export default "__VITE_ASSET__BriSN7pX__"